import React, { useEffect } from 'react';

import marcus from '@/assets/images/marcus.png';
import { Footer } from '@/layouts/Footer';

import { FTUPage } from '@bypasslane/clover--web-lib-sprout-ftu-page';
import PropTypes from 'prop-types';

const WelcomePage = ({ children = null, isSuperAdmin = false }) => {
  useEffect(() => {
    if (!isSuperAdmin) return;
    const svgElement = document.querySelector('.custom-ftu-page svg');
    if (svgElement) {
      const imgElement = document.createElement('img');
      imgElement.src = marcus; // Marcus image
      imgElement.alt = 'Marcus Image';
      imgElement.style.width = '100%'; // Adjust styles as needed
      imgElement.style.height = 'auto';
      imgElement.style.borderRadius = '50%'; // Make it circular
      imgElement.classList.add('animate-jiggle');
      svgElement.replaceWith(imgElement); // Replace SVG with the image
    }
  }, [isSuperAdmin]);

  return (
    <div className="custom-ftu-page">
      <FTUPage title="Manage Your Account" footerChildren={<Footer />}>
        {children}
      </FTUPage>
    </div>
  );
};

export default WelcomePage;
WelcomePage.propTypes = {
  children: PropTypes.node,
  isSuperAdmin: PropTypes.bool
};
